export const VI_ICON = "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/contact-sales-110324/checkmark-contact-sales.png";
